import React, { useState } from "react";
import { TextField, Button, Grid, Box } from "@mui/material";

function Form({ onAdd }) {
  const [formData, setFormData] = useState({
    numeroRegistro: "",
    nome: "",
    resultado: "",
    dataNascimento: "",
    sexo: "", // Novo campo para o sexo
    numeroFamilia: "",
    local: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onAdd(formData);
    setFormData({
      numeroRegistro: "",
      nome: "",
      resultado: "",
      dataNascimento: "",
      sexo: "",
      numeroFamilia: "",
      local: "",
    });
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ mb: 3 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Número de Registro"
            name="numeroRegistro"
            value={formData.numeroRegistro}
            onChange={handleChange}
            required
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Nome"
            name="nome"
            value={formData.nome}
            onChange={handleChange}
            required
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Resultado"
            name="resultado"
            value={formData.resultado}
            onChange={handleChange}
            required
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Data de Nascimento"
            name="dataNascimento"
            type="date"
            value={formData.dataNascimento}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            required
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Sexo"
            name="sexo"
            value={formData.sexo}
            onChange={handleChange}
            required
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Número da Família"
            name="numeroFamilia"
            value={formData.numeroFamilia}
            onChange={handleChange}
            required
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Local"
            name="local"
            value={formData.local}
            onChange={handleChange}
            required
          />
        </Grid>
      </Grid>
      <Button
        type="submit"
        variant="contained"
        sx={{ mt: 2 }}
        fullWidth
        color="primary"
      >
        Cadastrar
      </Button>
    </Box>
  );
}

export default Form;
